export function formatMobile(mobile) {
    let mob = mobile?.split('')
    let number = []
    for(let i = 0; i<mob?.length; i++) {
        if(i === 0) {
            number.push(' (')
            // number.push('+')
            number.push(mob[i])
        }  else if( i === 3 ) {
            number.push(') ')
            number.push(mob[i])
        } else if( i === 6 ) {
            number.push('-')
            number.push(mob[i])
        } else {
            number.push(mob[i])
        }
    }
    return number.join('')
}
export function formatCardNumber(card) {
    let cardDetail = card?.split('')
    let cardNum = []
    for(let i = 0; i<cardDetail?.length; i++) {
        if(i === 4 || i === 8) {
            cardNum.push(' ')
            cardNum.push('X')
        } else if((i >= 0 && i < 4) || (i > 3 && i < 8) || (i > 7 && i < 12)) {
            cardNum.push('X')
        } else if(i === 12 || i === 16) {
            cardNum.push(' ')
            cardNum.push(cardDetail[i])
        } else {
            cardNum.push(cardDetail[i])
        }
    }
    return cardNum.join('')
}